import { translate } from '../../Services/translation';
import CheckoutStorePickup from '../Checkout.StorePickup';
import React from 'react';

const renderCheckoutStorePickup = ({ checkout, setSelectedReseller }) => {
  const { payload } = checkout;
  const { storeView } = payload;
  const { defaultStore, stores } = storeView;

    const onDealerSelect = e => {
        e.stopPropagation();
        const nextButton =
            document.querySelector('.checkout__step.active .checkout__step-content-next button');
        nextButton.click();
    }

  const storesIndexed = stores
    .filter((storeObj) => storeObj.isPickup)
    .map((storeObj, index) => ({
      ...storeObj,
      index: index,
    }));
  return (
    <div className="checkout-storepickup">
      <h3 className="checkout__section-title">
        {translate('checkout.storepicker.title')}
      </h3>
      <CheckoutStorePickup
        {...{
          defaultStore,
          stores: storesIndexed,
          setSelectedReseller,
          onDealerSelect: onDealerSelect
        }}
      />
    </div>
  );
};

export default renderCheckoutStorePickup;
